export enum CommunityFormEnum {
    OPEN_DISCUSSION = 1,
    MASTERMIND_CIRCLE = 2
}